import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=c501d1a2&scoped=true&"
import script from "./RowItem.vue?vue&type=script&lang=js&"
export * from "./RowItem.vue?vue&type=script&lang=js&"
import style0 from "./RowItem.vue?vue&type=style&index=0&id=c501d1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c501d1a2",
  null
  
)

export default component.exports